export const VERSION_REQUEST = 'VERSION_REQUEST'
export const SETTINGS_REQUEST = 'SETTINGS_REQUEST'
export const SET_SETTINGS_REQUEST = 'SET_SETTINGS_REQUEST'
export const SETTINGS_SUCCESS = 'SETTINGS_SUCCESS'
export const SETTINGS_ERROR = 'SETTINGS_ERROR'
export const SET_POLICY = 'SET_POLICY'
